// GENERATED FILE - DO NOT MODIFY

export enum GetCheckInsSortColumnDto {
    Date = "Date",
    FirstName = "FirstName",
    LastName = "LastName",
    Email = "Email",
    LocationName = "LocationName",
}